import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import pkg from '../package.json'

Vue.use(Router)

const env = process.env.VUE_APP_ENV
const { endpoint, endpointLocal, endpointStaging } = pkg.config

// const src =
//   env === 'development' && !endpointStaging
//     ? endpointLocal
//     : env === 'staging' || env === 'development'
//     ? endpointStaging
//     : endpoint

const src = endpoint

const home = () => import(/* webpackChunkName: "home" */ './views/Home.vue')

const viewer = () =>
  import(/* webpackChunkName: "viewer" */ './views/Viewer.vue')

const media = () => import(/* webpackChunkName: "media" */ './views/Media.vue')

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/campus',
    name: 'campus',
    meta: { back: 'home', campus: true },
    component: viewer,
    children: [
      {
        path: ':category_id',
        name: 'campus-category',
        meta: { back: 'campus', campus: true }
      },
      {
        path: ':category_id/:media_id',
        name: 'campus-media',
        meta: { back: 'campus-category', campus: true, media: true },
        components: {
          media: media
        }
      },
      {
        path: ':category_id/:media_id/:panorama_id',
        name: 'campus-panorama',
        meta: { back: 'campus-category', panorama: true }
      },
      {
        path: ':category_id/:media_id/:panorama_id/:hotspot_id',
        name: 'campus-hotspot',
        meta: { back: 'campus-panorama', panorama: true, media: true },
        components: {
          media: media
        }
      }
    ]
  },
  {
    path: '/guided-tour',
    name: 'guided-tour',
    meta: { back: 'home', guided: true, panorama: true },
    component: viewer,
    children: [
      {
        path: ':panorama_id',
        name: 'guided-panorama',
        meta: { back: 'guided-tour', guided: true, panorama: true }
      },
      {
        path: ':panorama_id/:hotspot_id',
        name: 'guided-hotspot',
        meta: {
          back: 'guided-panorama',
          guided: true,
          panorama: true,
          media: true
        },
        components: {
          media: media
        }
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.posts.length) {
    Promise.all([
      fetch(`${src}/rv/v1/basis?per_page=-1`).then(res => res.json())
    ])
      .then(([res]) => {
        store.commit({
          type: 'populate',
          posts: res,
          error: null
        })
        store.commit('route', to)
        next()
        store.commit('isLoading', false)
      })
      .catch(err => {
        store.commit({
          type: 'populate',
          error: err
        })
      })
  } else {
    store.commit('isLoading', true)
    store.commit('route', to)
    next()
    store.commit('isLoading', false)
  }
})

export default router
